export const offersAction = (payload) => ({
    type: 'OFFERS',
    payload
})

export const ordersAction = (payload) => ({
    type: 'ORDERS',
    payload
})

export const ticketsAction = (payload) => ({
    type: 'TICKETS',
    payload
})

export const orderAction = (payload) => ({
    type: 'ORDER',
    payload
})

export const usersAction = (payload) => ({
    type: 'USERS',
    payload
})